import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-noticeDetail"
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm.info.img_url ? _c('div', {
    staticClass: "container-head"
  }, [_c('img', {
    attrs: {
      "src": _vm.info.img_url,
      "alt": ""
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "container-title"
  }, [_vm._v(" " + _vm._s(_vm.info.title) + " ")]), _c('div', {
    staticClass: "container-extra"
  }, [_vm._v(i18n.tc("475") + _vm._s(_vm.info.create_name) + (" " + i18n.tc("476")) + _vm._s(_vm.info.create_time))]), _c('div', {
    staticClass: "container-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.info.content)
    }
  })])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };